module Meevo.Plugins.Client {

    export interface IClientDuplicatesSearchService {
        readonly hasDuplicates: boolean;
        readonly requiredDataExists: boolean;
        readonly modelIsSet: boolean;
        readonly settingsIsSet: boolean;
        readonly lastSearchResult: Model.Client[];
        readonly valid: boolean;

        setModel(model: Model.Client): void;
        setClientSettings(clientSettings: Meevo.Plugins.BusinessInfo.IBusinessInfoClientsSettings): void;
        getDuplicates(SearchStrategyStatic?: IClientSearchStrategyStatic): ng.IPromise<Model.Client[]>;
        getDuplicatesByNamePhone(): ng.IPromise<Model.Client[]>;
        getDuplicatesByEmail(): ng.IPromise<Model.Client[]>;
        showWarning(modalService: Meevo.Components.Modal.IModalService): ng.IPromise<any>;
    }

    export class ClientDuplicatesSearchService implements IClientDuplicatesSearchService {


        private searchStrategy: IClientSearchStrategy;

        private _lastSearchResult: Model.Client[];

        get valid(): boolean {
            return this.searchStrategy && this.searchStrategy.valid;
        }

        get hasDuplicates(): boolean {
            return this._lastSearchResult instanceof Array && this._lastSearchResult.length > 0;
        }

        get lastSearchResult(): Model.Client[] {
            return this._lastSearchResult;
        }

        get requiredDataExists(): boolean {
            return this.modelIsSet && this.settingsIsSet;
        }

        get modelIsSet(): boolean {
            return this.model !== undefined;
        }

        get settingsIsSet(): boolean {
            return this.clientSettings !== undefined;
        }

        constructor(private appSettings: Components.Common.IAppSettings,
                    private dataService: Meevo.Components.BaseClasses.IDataService,
                    private model: Model.Client,
                    private clientSettings: Meevo.Plugins.BusinessInfo.IBusinessInfoClientsSettings,
                    private $q: ng.IQService,
                    SearchStrategyStatic?: IClientSearchStrategyStatic) {
            if (SearchStrategyStatic) {
                this.searchStrategy = new SearchStrategyStatic(appSettings, model, dataService, $q);
            }
        }

        public setModel(model: Model.Client): void {
            this.model = model;
        }

        public setClientSettings(clientSettings: Meevo.Plugins.BusinessInfo.IBusinessInfoClientsSettings): void {
            this.clientSettings = clientSettings;
        }

        public getDuplicates(SearchStrategyStatic?: IClientSearchStrategyStatic): ng.IPromise<Model.Client[]> {
            if (SearchStrategyStatic) {
                this.searchStrategy = new SearchStrategyStatic(this.appSettings, this.model, this.dataService, this.$q);
            }

            return this.searchStrategy
                .search()
                .then(list => {
                    this._lastSearchResult = list;
                    return list;
                });
        }

        public getDuplicatesByNamePhone(): ng.IPromise<Model.Client[]> {
            return this.getDuplicates(NamePhoneSearchStrategy);
        }

        public getDuplicatesByEmail(): ng.IPromise<Model.Client[]> {
            return this.getDuplicates(EmailSearchStrategy);
        }

        public showWarning(modalService: Meevo.Components.Modal.IModalService): ng.IPromise<any> {
            return this
                .searchStrategy
                .showWarning(modalService, this._lastSearchResult);
        }
    }
}
